import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { completeAuthentication } from '../../actions/routines';
import history from '../../history';

/**
 * Landing route for token hand-offs: UpFresh SSO and
 * `/api/auth/login-as-demo` both redirect here with a fresh token pair.
 * Choosing where to send the user is the saga's job.
 *
 * The tokens normally arrive through `security/ssoHandoff`, which has already
 * moved them out of the URL and into storage before this ever renders — see
 * that module for why. The route params are the fallback for the case where
 * it did not run, so this component keeps working either way.
 */
const TokenAuth = ({
    match: {
        params: { token, refreshToken },
    },
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const tokens = token
            ? { access_token: token, refresh_token: refreshToken }
            : {
                  access_token: localStorage.token,
                  refresh_token: localStorage.refreshToken,
              };

        if (!tokens.access_token || !tokens.refresh_token) {
            // Nothing to authenticate with — someone opened the route by hand.
            history.replace('/');

            return;
        }

        dispatch(completeAuthentication({ tokens }));
    }, [dispatch, token, refreshToken]);

    return <FormattedMessage id="security.logging_in" />;
};

TokenAuth.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            token: PropTypes.string,
            refreshToken: PropTypes.string,
        }).isRequired,
    }).isRequired,
};

export default TokenAuth;
